import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
var Heading = {
  base: css(["font-weight:", ";"], theme('fannypack.fontWeights.semibold')),
  h6: css(["font-size:1.125rem;"])
};
export default Heading;